import React, { useEffect, useState } from "react";
import { Chat, Streami18n } from "stream-chat-react";
import { streamService } from "../../../utils/StreamService";
import { useTheme } from "../../../hooks/useTheme";
import { useAuth } from "../../../hooks/useAuth";
import { AuthenticationStatus, AuthenticationStatusGetStream } from "../../../store/slices/authSlice";
import { StreamVideo, StreamTheme, Call, StreamCall, CancelCallButton, Restricted, OwnCapability, SpeakingWhileMutedNotification, ToggleAudioPublishingButton, ToggleVideoPublishingButton, ReactionsButton, SpeakerLayout } from "@stream-io/video-react-sdk";
import { useStream } from "../../../hooks/useStream";

interface StreamContainerProps {
    children: React.ReactNode;
}

const StreamContainer = ({ children }: StreamContainerProps) => {
    const { isDarkMode } = useTheme();
    const { status } = useAuth();
    const { currentCallData } = useStream();
    const [call, setCall] = useState<Call | undefined>(undefined);

    useEffect(() => {
        setCall(streamService.getCurrentCall());
    }, [currentCallData]);

    const i18nInstance = new Streami18n({ 
        language: "en",
        translationsForLanguage: {
          "Type your message": "Message",
        },
      });

    const renderChildren = () => {
        if(status !== AuthenticationStatus.INITIAL && status !== AuthenticationStatus.LOGGING_OUT) {
            const videoClient = streamService.getVideoClient();
    
            if(videoClient) {
                return <StreamVideo client={videoClient}>
                    <StreamTheme>
                        <StreamCall call={call}>
                            {children}
                        </StreamCall>
                    </StreamTheme>
                </StreamVideo>
            }
        }

        return children;
    }
    
    return (
        <Chat 
            client={streamService.getChatClient()} 
            theme={isDarkMode ? "str-chat__theme-dark" : "str-chat__theme-light"}
            i18nInstance={i18nInstance}
        >
            {renderChildren()}
        </Chat>
    )
}

export default StreamContainer;